// Module
var code = "<mn-procedure-table details=\"vm.item.details\" read-only=\"true\" flex></mn-procedure-table>";
// Exports
module.exports = code;